import React from "react";
import { Box, Typography, Chip } from "@mui/material";

export const getStatusBadgeConfig = (item) => {
  if (!item) return { label: "Upcoming", bg: "#EFF8FF", color: "#175CD3", dot: "#2E90FA" };
  if (item.status === 0) {
    return { label: "Disabled", bg: "#F2F4F7", color: "#344054", dot: "#667085" };
  }
  if (item.is_completed === 1) {
    return { label: "Completed", bg: "#ECFDF5", color: "#027A48", dot: "#12B76A" };
  }
  if (item.is_live) {
    return { label: "Live", bg: "#FEF3F2", color: "#B42318", dot: "#F04438" };
  }
  return { label: "Upcoming", bg: "#EFF8FF", color: "#175CD3", dot: "#2E90FA" };
};

export const StatusDotBadge = ({ item }) => {
  const badge = getStatusBadgeConfig(item);

  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          bgcolor: badge.dot,
        }}
      />
      <Typography
        variant="caption"
        fontWeight={700}
        sx={{ color: badge.color, fontSize: "0.65rem" }}
      >
        {badge.label}
      </Typography>
    </Box>
  );
};

export const StatusChip = ({ item }) => {
  const badge = getStatusBadgeConfig(item);

  return (
    <Chip
      label={badge.label}
      size="small"
      sx={{
        bgcolor: badge.bg,
        color: badge.color,
        fontWeight: 600,
        fontSize: "0.75rem",
        height: 24,
        borderRadius: "12px",
      }}
    />
  );
};